<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column is-8">
          <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <swiper-slide v-for="(n) in news" :key="n.uuid">
              <img :src="'https://api.plataformasocialmedia.pw'+n.images[0].path+'/'+n.images[0].file_name" :alt="n.title"/>
              <div class="carrousel-container">
                <h1 class="title is-3 has-text-light">{{n.title}} </h1>
                <router-link :to="{name:'NoticiasPage',params:{slug:n.slug}}" class="button is-danger">Leer más</router-link>
              </div>
            </swiper-slide>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </swiper>

          <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
            <swiper-slide v-for="(n) in news" :key="n.uuid">
            <img :src="'https://api.plataformasocialmedia.pw'+n.images[0].path+'/small/'+n.images[0].file_name" :alt="n.title"/>
            </swiper-slide>
          </swiper>

        </div>

        <div class="column is-4">

          <a href="https://mariomachuca.com" target="_blank"><img :src="bannermm"/></a>

          <div class="video-container">
              <iframe src="https://www.youtube.com/embed/B3RtRnkIiAY" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
          </div>

        </div>

      </div>
    </div>

    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <h2 class="title is-3"> Videos </h2>
          <div class="columns">
            <div class="column is-4" v-for="(v, index) in video">
              <div class="video-container">
                  <iframe :src="v.video" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
              </div>
              <p>{{v.title}}</p>
            </div>
          </div>
          <router-link to="/videos" class="button is-danger is-medium">Ver más</router-link>

        </div>
      </div>
    </section>

    <div class="container">
      <h2 class="title is-3 mt1"> Nuestras Redes Sociales </h2>

      <div class="columns mt-01">


        <div class="column is-6">
          <timeline :id="'CrocCancun'" :sourceType="'profile'" :options="{ tweetLimit: '2'}"></timeline>
        </div>

        <div class="column is-6">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fcroccancun&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=620749832085102" width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Timeline from 'vue-tweet-embed/timeline'
import bannermmhome from '@/assets/img/bannermariomachucanew.jpeg'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueLodash from 'vue-lodash'

export default {
  name: 'Home',
  data () {
    return {
      news:[],
      video:[],
      bannermm:bannermmhome,
      swiperOptionTop: {
         spaceBetween: 10,
         loop: true,
         loopedSlides: 5, //looped slides should be the same
         navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev'
         }
       },
       swiperOptionThumbs: {
         spaceBetween: 10,
         slidesPerView: 4,
         touchRatio: 0.2,
         loop: true,
         loopedSlides: 5, //looped slides should be the same
         slideToClickedSlide: true,
       },
    }
  },
  computed: {
  },
  components: {
    'timeline': Timeline,
    swiper,
    swiperSlide,
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods:{
    init(){
      axios.all([
        axios.post(process.env.API_URL_V1+'news?api_token='+process.env.API_TOKEN_V1,{type_web:'croc','limit':6}),
        axios.post(process.env.API_URL_V1+'video?api_token='+process.env.API_TOKEN_V1,{type_web:'croc'})
      ])
      .then(axios.spread((newsData, videoData) => {
        this.news=newsData.data.data;
        this.video=_.take(videoData.data.data,3);
      })).catch((err) =>{

      });
    }

  },
  created :function(){
    this.init();
  }
}
</script>

<style scoped>
.mt1{
  margin-top:2rem;
}
@media screen and (min-width: 768px){
  .carrousel-container{
    margin-top: -2rem;
    font-size: 1rem;
  }
}
.carrousel-container{
  position: absolute;
  margin-top: -12rem;
  left: 10%;
  right: 10%;
}
.gallery-top {
  height: 80%!important;
  width: 100%;
}
.gallery-thumbs {
  height: 20%!important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.twitter{
  width: 400px;
  height: 400px;
}
#weather {
  margin: auto;
  margin-bottom: 1rem;
  display: block;
}
#display {
  padding: 20px 16px 24px 16px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
}
#top {
  margin-bottom: 20px;
}

#top .location {
  font-size: 24px;
  line-height: 1.2;
}

#top .time {
  font-size: 16px;
  line-height: 2;
}

#top .status {
  font-size: 13px;
  line-height: 1.4
}

.thumbnail {
  height: 64px;
  width: 64px;
}

.temperature {
  margin-top: -3px;
  padding-left: 10px;
  font-size: 64px;
}

.unit {
  margin-top: 6px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue